export const qualifyUrl = (url: string): string => new URL(process.env.INFOPOINT_SERVER + url).toString()
